import Table, { ColumnsType } from "antd/es/table";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import s from "./MobileUsersListTable.module.scss";
import moment from "moment";
import { Button, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { getApplicationDetails } from "../../redux/ApplicationSlice";
import { IUserListResponseResults } from "../../types";
import {
  getAdminUsersList,
  getUserDetails,
  setUsersCurrentPage,
} from "../../redux/UserSlice";
import { useTranslation } from "react-i18next";

interface IMobileTable {
  number: number;
  name: string;
  common_info: any;
}

const MobileUsersListTable = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const users = useSelector((state: RootState) => state.user.adminUsersList);
  const { t } = useTranslation();

  const [pagination, setPagination] = useState({
    current: users?.pagination?.current_page || 1,
    pageSize: users?.pagination?.page_size || 30,
    total: users?.pagination?.total_items || 100,
  });
  const [data, setData] = useState<IUserListResponseResults[] | undefined>(
    users?.results
  );
  const [currentPage, setCurrentPage] = useState<number>(
    users?.pagination?.current_page || 1
  );

  const currentPageRef = useRef(currentPage);

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);

  // useEffect(() => {
  //   const fetchData = async (page: number) => {
  //     const res = await dispatch(getAdminUsersList(page));

  //     if (res.payload && res.type === "users/getAdminUsersList/fulfilled") {
  //       if ("results" in res.payload) {
  //         setData(res.payload.results);
  //         setPagination({
  //           current: res.payload.pagination?.current_page,
  //           pageSize: res.payload.pagination?.page_size,
  //           total: res.payload.pagination?.total_items,
  //         });
  //       } else {
  //         console.error("Unexpected API response:", res.payload);
  //       }
  //     }
  //   };
  //   fetchData(currentPageRef.current);

  //   const interval = setInterval(() => {
  //     fetchData(currentPageRef.current);
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [dispatch]);

  const getNextPage = async (page: number) => {
    setCurrentPage(page);
    dispatch(setUsersCurrentPage(page));
    currentPageRef.current = page;

    if (page === undefined || page === null) return;

    try {
      const res = await dispatch(getAdminUsersList(page));
      if (!res.payload || !("results" in res.payload)) {
        console.error("Unexpected API response:", res);
        return;
      }

      if (res.type === "users/getAdminUsersList/fulfilled") {
        if ("results" in res.payload) {
          setData(res?.payload?.results);
          setPagination({
            current: res?.payload?.pagination?.current_page,
            pageSize: res?.payload?.pagination.page_size,
            total: res.payload.pagination.total_items,
          });
        } else {
          console.error("Unexpected API response:", res.payload);
        }
      }
    } catch (error) {
      console.error("Error in getNextPage:", error);
    }
  };

  const columns: ColumnsType<IMobileTable> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("ФИО пользователя"),
      dataIndex: "name",
      width: 100,
      // align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Информация"),
      dataIndex: "common_info",
      width: 200,
      align: "center",
    },
  ];

  const getPaymentAmount = async (id: number) => {
    const res = await dispatch(getApplicationDetails(id));
    if (res.type === "applications/getApplicationDetails/fulfilled") {
      navigate(`/payment/${id}`);
    }
  };

  return (
    <div>
      <Table
        bordered
        pagination={{ ...pagination, size: "small" }}
        columns={columns}
        className={"mobile_table"}
        onChange={(pagination) => {
          if (pagination?.current) {
            getNextPage(pagination.current);
          }
        }}
        dataSource={data?.map((it, index) => ({
          number: index + 1,
          name: it?.full_name,
          common_info: (
            <div>
              <div className={s.table_item}>
                <div className={s.item_name}>{t("Email")}: </div>
                <div className={s.item_value}>{it?.email}</div>
              </div>
              <div className={s.table_item}>
                <div className={s.item_name}>{t("Телефон")}: </div>
                <div className={s.item_value}>{it?.phone}</div>
              </div>
              <div className={s.table_item}>
                <div className={s.item_name}>{t("Роль")}: </div>
                <div className={s.item_value}>{it?.role}</div>
              </div>
              <div className={s.table_item}>
                <div className={s.item_name}>{t("Активный")}: </div>
                <div className={s.item_value}>
                  {it?.is_active ? (
                    <CheckCircleOutlined className={s.green} />
                  ) : (
                    <CloseCircleOutlined className={s.red} />
                  )}
                </div>
              </div>
              <div className={s.table_item}>
                <div className={s.item_name}>{t("Верифицирован")}: </div>
                <div className={s.item_value}>
                  {it?.email_verified ? (
                    <CheckCircleOutlined className={s.green} />
                  ) : (
                    <CloseCircleOutlined className={s.red} />
                  )}
                </div>
              </div>

              <div className={s.table_item}>
                <div className={s.item_name}>
                  {t("Просмотр/Редактирование")}:{" "}
                </div>
                <div className={s.item_value}>
                  <Link
                    to={`/user/${it.id}`}
                    className={s.edit}
                    onClick={() => it?.id && dispatch(getUserDetails(it.id))}
                  >
                    <Button className={s.btn}>
                      <Tooltip title={t("Редактировать заявку")} key={1}>
                        <EditOutlined />
                      </Tooltip>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ),
        }))}
      />
    </div>
  );
};

export default MobileUsersListTable;
